/**
 * useShareAnalysis Hook
 * React Query mutation hook for sharing analysis with external recipients
 */

import { useMutation } from '@tanstack/react-query';
import { shareService, type ShareAnalysisRequest, type ShareAnalysisResponse } from '@/services/api/share';

/**
 * Hook for sharing an analysis
 * Returns a mutation that creates a share and sends verification email
 */
export function useShareAnalysis() {
  return useMutation<ShareAnalysisResponse, Error, ShareAnalysisRequest>({
    mutationFn: shareService.shareAnalysis,
  });
}
